export const state = {
  role: undefined,
  roles: [],
  sousRechercherEmploi: undefined,
  sousRechercherEmplois: []
}